var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal-box-trans"}},[(_vm.show)?_c('div',{staticClass:"modal-box"},[(_vm.title)?_c('h1',{staticClass:"modal-box-title title-box"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('div',{staticClass:"modal-box-content"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }